<div class="rounded-2xl border border-gray-200 bg-white pt-4">

    <!-- Title -->
    <div class="flex justify-between items-center px-6 mb-4">

        <h3 class="text-lg font-semibold text-gray-800">
            {{ title }}
        </h3>

        <input type="text" [(ngModel)]="searchTerm" (input)="applyFilters()" placeholder="Search..."
            class="h-10 w-64 rounded-lg border border-gray-300 px-4 text-sm focus:ring-2 focus:ring-brand-500" />

    </div>


    <!-- Table -->
    <div class="overflow-x-auto px-6">
        <table class="min-w-full">
            <thead class="border-y">
                <tr>
                    <th *ngFor="let col of columns" (click)="sort(col)"
                        class="px-4 py-3 text-start text-sm text-gray-500 cursor-pointer select-none">

                        <div class="flex items-center gap-1">
                            {{ col.header }}

                            <span *ngIf="sortField === col.field">
                                {{ sortDirection === 'asc' ? '▲' : '▼' }}
                            </span>
                        </div>
                    </th>
                </tr>
            </thead>

            <tbody class="divide-y">
                <tr *ngFor="let item of currentItems">
                    <td *ngFor="let col of columns" class="px-4 py-4 text-sm text-gray-700">
                        <!-- {{ columns | json }} -->
                        <!-- Custom Template -->
                        <ng-container *ngIf="col.cellTemplate; else checkType">
                            <ng-container *ngTemplateOutlet="col.cellTemplate; context: { $implicit: item }">
                            </ng-container>
                        </ng-container>

                        <ng-template #checkType>

                            <!-- Profile Column -->
                            <ng-container *ngIf="col.type === 'profile'; else checkArray">
                                <div class="flex items-center gap-3">
                                    <img [src]="item.profileImage" class="w-8 h-8 rounded-full object-cover" />
                                    <span class="text-sm font-medium text-gray-800">
                                        {{ item.name }}
                                    </span>
                                </div>
                            </ng-container>

                        </ng-template>

                        <ng-template #checkArray>
                            <!-- Array Column (Skillset) -->
                            <ng-container *ngIf="col.type === 'array'; else checkRating">
                                <div class="flex flex-wrap gap-1">
                                    <span *ngFor="let skill of item[col.field]"
                                        class="px-2 py-1 text-xs bg-gray-100 rounded-md">
                                        {{ skill }}
                                    </span>
                                </div>
                            </ng-container>
                        </ng-template>

                        <ng-template #checkRating>
                            <!-- Rating Column -->
                            <ng-container *ngIf="col.type === 'rating'; else checkBadge">
                                <div class="flex items-center gap-1 text-yellow-500">
                                    <span *ngFor="let star of [1,2,3,4,5]">
                                        {{ star <= item.rating ? '★' : '☆' }} </span>
                                            <span class="text-xs text-gray-500 ml-1">
                                                ({{ item.rating }})
                                            </span>
                                </div>
                            </ng-container>
                        </ng-template>

                        <ng-template #checkBadge>
                            <!-- Badge Column -->
                            <ng-container *ngIf="col.type === 'badge'; else normalCell">
                                <app-badge size="sm" [color]="getBadgeColor(item[col.field])">
                                    {{ item[col.field] }}
                                </app-badge>
                            </ng-container>
                        </ng-template>

                        <ng-template #normalCell>
                            {{ item[col.field] }}
                        </ng-template>

                        <!-- Badge 
                        <ng-container *ngIf="col.type === 'badge'; else normalCell">
                            <app-badge size="sm" [color]="getBadgeColor(item[col.field])">
                                {{ item[col.field] }}
                            </app-badge>
                        </ng-container>
                       

                       Actions 
                        <ng-container *ngIf="col.type === 'actions'">
                            <div class="flex items-center gap-3">

                                <button (click)="edit.emit(item)" class="text-primary hover:underline text-sm">
                                    Edit
                                </button>

                                <button (click)="delete.emit(item)" class="text-red-500 hover:underline text-sm">
                                    Delete
                                </button>

                            </div>
                        </ng-container> -->
                        <!-- <ng-template #normalCell>
                            {{ item[col.field] }}
                        </ng-template> -->

                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <!-- Pagination -->
    <div class="px-6 py-4 border-t flex items-center justify-between">

        <button (click)="goToPage(currentPage - 1)" [disabled]="currentPage === 1"
            class="px-3 py-1 rounded-lg border text-sm disabled:opacity-50">
            Previous
        </button>

        <div class="flex gap-1">
            <button *ngFor="let page of [].constructor(totalPages); let i = index" (click)="goToPage(i + 1)"
                class="h-8 w-8 rounded-lg text-sm" [ngClass]="{
        'bg-brand-500 text-white': currentPage === i + 1,
        'hover:bg-brand-100': currentPage !== i + 1
      }">
                {{ i + 1 }}
            </button>
        </div>

        <button (click)="goToPage(currentPage + 1)" [disabled]="currentPage === totalPages"
            class="px-3 py-1 rounded-lg border text-sm disabled:opacity-50">
            Next
        </button>

    </div>

</div>